export default __webpack_public_path__ + "static/media/55t.d8a09cea.jpg";